module.exports = __webpack_public_path__ + "img/assertiveness_breatheDeep.e3cbcd30.png";